export const MAX_SMS_LENGTH = 1600;

export const getSmsLength = (text: string): number => text.length;

export const exceedsSmsLimit = (length: number): boolean =>
  length >= MAX_SMS_LENGTH;

export const isOverSmsLimit = (text: string): boolean =>
  exceedsSmsLimit(getSmsLength(text));
